import React, { Fragment, useEffect, useState } from "react";
import { Menu, Dropdown } from 'antd';
import styles from "./scss/eventlist.module.scss";
import { URButton } from "../../../shared/widgets/button";
import { URInput } from "../../../shared/widgets/input";
import { StatusTag } from "../../../shared/widgets/statusTag";
import moment from "moment";
//import CreateEventRight from "./eventcreateright";
import _ from "lodash";
import { chatwindowDetails, initialStateModel, LoginState, rightSidePanelDetails } from "../../../models/model";
import { useSelector } from "react-redux";
import { complete_event_status, handleDatePickers } from "../../../base/utils";
import NotFound from "../../../styles/images/empty_states/event_empty_state.svg";
import NoContent from "../../../shared/widgets/noContent";
import { chatSideWindow } from "../../../base/eventService/eventApiService";
import {DatePicker} from "antd";
import { UREventsSkeleton } from "../../../shared/skeletonLoading/eventsSkeleton";
import { HighlightInner } from "../../contacts/rightsidebar/highlight";

const { RangePicker } = DatePicker;
type EventPageState = {
  searchEvent: any;
  filterKey:string;
  isSearch:boolean;
  eventlist:any;
  tempeventList:any;
  searchText:string;
  isCalender:boolean,
  isFilter:boolean;
}
type eventProps ={
  eventsDetails:any;
}
export default function EventListsRight({eventsDetails}:eventProps) {

  const rightSideLink: rightSidePanelDetails = useSelector((state: initialStateModel) =>
    state.chatRightSidePanelReducer);
  const { chatWindowDetails }: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  const {userdetails}: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  const [eventList, seteventList] = useState<EventPageState>({
    searchEvent:[],tempeventList:[],searchText:"",
    filterKey:"All",isFilter:false,
    isSearch:false,
    isCalender:false,
    eventlist:[]});

  useEffect(() => {
    seteventList({...eventList,searchEvent:eventsDetails,eventlist:eventsDetails,tempeventList:eventsDetails});
   
  }, [eventsDetails?.length]);
  
  const showCreateEvent =()=>{
    chatSideWindow(true,"event",{});
    //setOpenEventModal(status);
  };

  const selectfilter = (val:any)=>{
    let status:any = val.key;
    let response : Array<any> = [];
    if (val.key === "All" || val.key === "Calender"){
      response = eventList.eventlist;
    } else {
      response = _.filter(eventList.eventlist,(element:any)=>{
        return  complete_event_status((element?.dtstart)*1000, (element?.dtend)*1000) === status;
      });
    }
    seteventList({...eventList,searchEvent:response,tempeventList:response,filterKey:val.key
    });
  };

  const  handleDatePicker = (e: any) => {
    if(e){
      let response=handleDatePickers(e,eventList.eventlist);
      seteventList({...eventList,
        searchEvent:response,tempeventList:response
      });
    }
  };
  
  const searchEventkinList=(e:any)=>{
    let searchText=e.target.value.toLowerCase();
    let response:any =   _.filter(eventList?.tempeventList, function(data:any) {
      let TaskName = data?.summary || "";
      let Datesearch = moment(new Date(parseInt(data?.dtstart)*1000)).format("ddd, MMM Do YYYY") || '';
      return (((TaskName).toLowerCase()).includes(searchText) ||
      (Datesearch.toString()).toLowerCase().includes(searchText));
      
    });
    seteventList({...eventList,searchEvent:response,searchText:searchText});
  };

  const menu = (
    <Menu className="rightdropactions" onClick={selectfilter}>
      <Menu.Item className={eventList.filterKey==='All'?
        "active":''}  key={'All'}><span className="icon_tick"></span><b>All</b></Menu.Item>
     {/*  <Menu.Item className={eventList.filterKey==='Calender'?
        "active":''}  key={'Calender'}><span className="icon_tick"></span><b>Calender</b></Menu.Item> */}
      <Menu.Item className={eventList.filterKey==='Yet To start'?
        "active":''}
      key={'Yet To start'}><span className="icon_tick" ></span><b>
          <StatusTag className='statusyettoStart' name='Yet To start' /></b></Menu.Item>
      <Menu.Item
        className={eventList.filterKey==='In Progress'?
          "active":''}
        key={'In Progress'}><span className="icon_tick"  ></span><b>
          <StatusTag className='statusunderinProgress' name='In Progress' /></b></Menu.Item>
      <Menu.Item className={eventList.filterKey==='Completed'?
        "active":''}
      key={'Completed'}><span className="icon_tick" ></span><b>
          <StatusTag className='statusCompleted' name='Completed'/></b></Menu.Item>
      
    </Menu>
  );
  // let storeItems = rightSideLink.eventListDetails.result
  // !== undefined ? rightSideLink.eventListDetails.result : eventList.searchEvent;
  const showEditEvent = (eventdata:any)=>{
    chatSideWindow(true,"editevent",eventdata);
  };
  let teamMemberOnly = chatWindowDetails.team_id &&
  chatWindowDetails?.team_members ? chatWindowDetails?.team_members.split(",").map((ele: any) => ele.trim()) : [];
  return (
    <>

      <div className={`fadeIn ${styles.eventmain}`}>
        <div className={styles.rightbartop}>
         { (teamMemberOnly.includes(userdetails.sip_login_id) || chatWindowDetails.sip_login_id )&& <div className={styles.eventnewbtn}>
         <span className={styles.titleText}>Event</span>
            <URButton className={`${"rightnewtask"} ${chatWindowDetails?.is_blocked === 1 && 'blockdisabled'}`} name="New Event" onClick={ showCreateEvent}/>
            {/*  <CreateEventRight/> */}
          </div>}
          <div className={styles.eventsearchbar}>
            <div className={styles.lefts}>
              <URInput placeHolder="Search" className="rightbarsearch" onChange={searchEventkinList} />
            </div>
            <div className={styles.rights}>
              <Dropdown className="popss2" overlay={menu} trigger={['click']}  placement="bottomRight">
                <p>{eventList.filterKey.length > 0 ?
                  eventList.filterKey :"All"}
                <span className={`icon_down-arrow menudroprotate`}></span>
                </p>
                
              </Dropdown>
            </div>
            {eventList.isCalender && <div className={styles.rights}>
              <RangePicker  className="customDatepicker"
                format={'DD/MM/YYYY'}
                onChange={(e: any)=>handleDatePicker(e)}
                  
              />
            </div> }
          </div>
        </div>
        {(!rightSideLink.isEvent && rightSideLink?.eventListDetails?.length ===0)?
          [1,2,3,4,5,6,7,8,9,10].map((data:any)=>(
            <div className={styles.skeletonSec} key={data}>
              <UREventsSkeleton key={data}/>
            </div>
          )):
          ( eventList?.searchEvent?.length === 0 &&rightSideLink.isEvent&&
         !rightSideLink?.eventLoader) ? <NoContent image={NotFound}
              title={"Worktual Events"}
              description={"Plan, Schedule and Execute."} />:
            rightSideLink.isEvent && !rightSideLink?.eventLoader&& <div className={styles.rightbarbottom}>
              {eventList?.searchEvent && eventList?.searchEvent?.length > 0 ?
                eventList?.searchEvent?.map((eventdata: any, i: any) => (
                  <Fragment key={i}>
                    <div className={`${styles.eventlist} ${styles.yellowbg}`}  onClick={() => showEditEvent(eventdata)}>
                      <div className={styles.toplayer}>
                        <h3><HighlightInner content={eventdata?.summary}
                        searchedData={eventList?.searchText}></HighlightInner></h3>
                        <div className={styles.status}>
                          {complete_event_status((eventdata.dtstart)*1000, (eventdata.dtend)*1000)
                          === "Completed" ?
                            <StatusTag className='statusCompleted' name="Completed" />:
                            complete_event_status((eventdata.dtstart)*1000, (eventdata.dtend)*1000)
                          === "Yet To start"?
                              <StatusTag className='statusyettoStart' name="Yet To start" /> :
                              complete_event_status((eventdata.dtstart)*1000, (eventdata.dtend)*1000)
                            === "In Progress"&&
                            <StatusTag className='statusunderinProgress' name="In Progress"/>
                          }
                        </div>
                      </div>
                      <div className={ !eventdata.location ?  styles.timeleftside : styles.topbottomlayer }>
                        <p className={styles.secondRow}>
                          <b>{eventdata.location}</b>
                        {eventdata.location ?<span> &bull;</span>:""}
                        <label >
                          {moment(new Date(parseInt(eventdata.dtstart)*1000)).format("ddd, MMM DD YYYY")}
                        </label>
                        </p>
                          {/* {moment(new Date(parseInt(eventdata.dtstart)*1000)).format("ddd, MMM Do YYYY")} */}
                      </div>
                    </div>
                  </Fragment>
                )) : null}
         
            </div>
        }
        
      </div>

    </>
  );
};

